var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('other-earnings-charges-table',{attrs:{"chargeList":_vm.charges}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }